"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _Sticky = _interopRequireDefault(require("@/components/Sticky"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'subShop',
  components: {
    Sticky: _Sticky.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      agentInfo: {},
      searchStatus: false,
      form: {},
      searchList: [],
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1,
        store_id: this.$route.query.store_id
      },
      vipDialog: false,
      vipInfo: {}
    };
  },
  mounted: function mounted() {
    this.agentInfo = window.agentInfo;
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) {
        this.form = {};
        this.searchStatus = false;
      } else {
        this.searchStatus = true;
        this.search();
      }
    },
    /**
     * 获取已添加的店员
     */
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/store/get_store_members';
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 搜索用户
     */
    search: function search() {
      var _this2 = this;
      this.$get('agentapi/search/query_users', this.form).then(function (res) {
        _this2.searchList = res.list;
      });
    },
    /**
     * 删除免费店员
     */
    delUser: function delUser(row, index) {
      var _this3 = this;
      this.$alert('确定删除此店员吗？', '删除店员', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this3.$post('agentapi/store/del_one_member', {
              store_id: _this3.listQuery.store_id,
              uid: row.id
            }).then(function (res) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.list.splice(index, 1);
            });
          }
        }
      });
    },
    /**
     * 添加免费店员
     */
    addUser: function addUser(row) {
      var _this4 = this;
      this.$alert('确定添加此用户为免费店员吗？', '添加店员', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this4.$post('agentapi/store/add_store_members', {
              store_id: _this4.listQuery.store_id,
              uid: [row.id]
            }).then(function (res) {
              _this4.$message({
                message: '添加成功',
                type: 'success'
              });
              _this4.getList();
              _this4.form = {};
              _this4.searchStatus = false;
            });
          }
        }
      });
    },
    /**
     * 设置单日使用次数
     */
    setDayCount: function setDayCount(row) {
      var _this5 = this;
      this.$post('agentapi/store/edit_members_day_count', {
        store_id: this.listQuery.store_id,
        uid: this.vipInfo.id,
        day_count: this.vipInfo.day_count,
        free_due_hours: this.vipInfo.free_due_hours
      }).then(function (res) {
        _this5.$message({
          message: '设置成功',
          type: 'success'
        });
        _this5.vipDialog = false;
        _this5.vipInfo.member_day_count = _this5.vipInfo.day_count;
        _this5.vipInfo.member_free_due_hours = _this5.vipInfo.free_due_hours;
      });
    }
  }
};